const STORAGE_KEY = 'havefun-theme-style';

interface ThemeVars {
  [key: string]: string;
}

export interface ThemeOption {
  key: string;
  label: string;
  icon: string;
}

export const themeOptions: ThemeOption[] = [
  { key: 'cyber', label: '赛博紫', icon: '🔮' },
  { key: 'tech', label: '科技蓝', icon: '💎' },
  { key: 'amber', label: '琥珀金', icon: '🔥' },
  { key: 'emerald', label: '翡翠绿', icon: '🌿' },
  { key: 'rose', label: '玫瑰粉', icon: '🌸' },
  { key: 'midnight', label: '午夜黑', icon: '🌙' },
  { key: 'ocean', label: '深海青', icon: '🌊' },
];

const themes: Record<string, ThemeVars> = {
  cyber: {
    '--theme-primary': '#7c3aed',
    '--theme-primary-light': '#8b5cf6',
    '--theme-primary-dark': '#6d28d9',
    '--theme-primary-rgb': '124, 58, 237',
    '--theme-accent': '#ec4899',
    '--theme-sidebar-bg': '#0d0b1a',
    '--theme-sidebar-bg2': '#1a1333',
    '--theme-content-bg': '#f5f3ff',
    '--theme-table-th': 'linear-gradient(180deg, #f8f5ff 0%, #f3f0ff 100%)',
    '--theme-table-th-color': '#4c1d95',
    '--theme-title-gradient': 'linear-gradient(90deg, #7c3aed, #6366f1)',
    '--theme-btn-gradient': 'linear-gradient(135deg, #7c3aed 0%, #6366f1 100%)',
    '--theme-btn-hover-gradient': 'linear-gradient(135deg, #8b5cf6 0%, #818cf8 100%)',
    '--theme-navbar-border': 'linear-gradient(90deg, rgba(124,58,237,.3), rgba(99,102,241,.1), transparent) 1',
    '--theme-sidebar-title': 'linear-gradient(90deg, #c4b5fd, #818cf8)',
  },
  tech: {
    '--theme-primary': '#2563eb',
    '--theme-primary-light': '#3b82f6',
    '--theme-primary-dark': '#1d4ed8',
    '--theme-primary-rgb': '37, 99, 235',
    '--theme-accent': '#06b6d4',
    '--theme-sidebar-bg': '#0b1120',
    '--theme-sidebar-bg2': '#111827',
    '--theme-content-bg': '#f0f4ff',
    '--theme-table-th': 'linear-gradient(180deg, #eff6ff 0%, #e0eaff 100%)',
    '--theme-table-th-color': '#1e3a5f',
    '--theme-title-gradient': 'linear-gradient(90deg, #2563eb, #06b6d4)',
    '--theme-btn-gradient': 'linear-gradient(135deg, #2563eb 0%, #0891b2 100%)',
    '--theme-btn-hover-gradient': 'linear-gradient(135deg, #3b82f6 0%, #22d3ee 100%)',
    '--theme-navbar-border': 'linear-gradient(90deg, rgba(37,99,235,.3), rgba(6,182,212,.1), transparent) 1',
    '--theme-sidebar-title': 'linear-gradient(90deg, #60a5fa, #22d3ee)',
  },
  amber: {
    '--theme-primary': '#d97706',
    '--theme-primary-light': '#f59e0b',
    '--theme-primary-dark': '#b45309',
    '--theme-primary-rgb': '217, 119, 6',
    '--theme-accent': '#ef4444',
    '--theme-sidebar-bg': '#1a1008',
    '--theme-sidebar-bg2': '#27190d',
    '--theme-content-bg': '#fffbf0',
    '--theme-table-th': 'linear-gradient(180deg, #fffbeb 0%, #fef3c7 100%)',
    '--theme-table-th-color': '#78350f',
    '--theme-title-gradient': 'linear-gradient(90deg, #d97706, #ef4444)',
    '--theme-btn-gradient': 'linear-gradient(135deg, #d97706 0%, #dc2626 100%)',
    '--theme-btn-hover-gradient': 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)',
    '--theme-navbar-border': 'linear-gradient(90deg, rgba(217,119,6,.3), rgba(239,68,68,.1), transparent) 1',
    '--theme-sidebar-title': 'linear-gradient(90deg, #fbbf24, #f87171)',
  },
  emerald: {
    '--theme-primary': '#059669',
    '--theme-primary-light': '#10b981',
    '--theme-primary-dark': '#047857',
    '--theme-primary-rgb': '5, 150, 105',
    '--theme-accent': '#14b8a6',
    '--theme-sidebar-bg': '#052e16',
    '--theme-sidebar-bg2': '#0a3d22',
    '--theme-content-bg': '#f0fdf4',
    '--theme-table-th': 'linear-gradient(180deg, #f0fdf4 0%, #dcfce7 100%)',
    '--theme-table-th-color': '#14532d',
    '--theme-title-gradient': 'linear-gradient(90deg, #059669, #14b8a6)',
    '--theme-btn-gradient': 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
    '--theme-btn-hover-gradient': 'linear-gradient(135deg, #10b981 0%, #2dd4bf 100%)',
    '--theme-navbar-border': 'linear-gradient(90deg, rgba(5,150,105,.3), rgba(20,184,166,.1), transparent) 1',
    '--theme-sidebar-title': 'linear-gradient(90deg, #6ee7b7, #5eead4)',
  },
  rose: {
    '--theme-primary': '#e11d48',
    '--theme-primary-light': '#f43f5e',
    '--theme-primary-dark': '#be123c',
    '--theme-primary-rgb': '225, 29, 72',
    '--theme-accent': '#ec4899',
    '--theme-sidebar-bg': '#1a0a10',
    '--theme-sidebar-bg2': '#2a1018',
    '--theme-content-bg': '#fff1f2',
    '--theme-table-th': 'linear-gradient(180deg, #fff1f2 0%, #ffe4e6 100%)',
    '--theme-table-th-color': '#881337',
    '--theme-title-gradient': 'linear-gradient(90deg, #e11d48, #ec4899)',
    '--theme-btn-gradient': 'linear-gradient(135deg, #e11d48 0%, #db2777 100%)',
    '--theme-btn-hover-gradient': 'linear-gradient(135deg, #f43f5e 0%, #f472b6 100%)',
    '--theme-navbar-border': 'linear-gradient(90deg, rgba(225,29,72,.3), rgba(236,72,153,.1), transparent) 1',
    '--theme-sidebar-title': 'linear-gradient(90deg, #fda4af, #f9a8d4)',
  },
  midnight: {
    '--theme-primary': '#6366f1',
    '--theme-primary-light': '#818cf8',
    '--theme-primary-dark': '#4f46e5',
    '--theme-primary-rgb': '99, 102, 241',
    '--theme-accent': '#a78bfa',
    '--theme-sidebar-bg': '#030712',
    '--theme-sidebar-bg2': '#0f172a',
    '--theme-content-bg': '#f1f5f9',
    '--theme-table-th': 'linear-gradient(180deg, #eef2ff 0%, #e0e7ff 100%)',
    '--theme-table-th-color': '#312e81',
    '--theme-title-gradient': 'linear-gradient(90deg, #6366f1, #a78bfa)',
    '--theme-btn-gradient': 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
    '--theme-btn-hover-gradient': 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    '--theme-navbar-border': 'linear-gradient(90deg, rgba(99,102,241,.3), rgba(167,139,250,.1), transparent) 1',
    '--theme-sidebar-title': 'linear-gradient(90deg, #a5b4fc, #c4b5fd)',
  },
  ocean: {
    '--theme-primary': '#0891b2',
    '--theme-primary-light': '#06b6d4',
    '--theme-primary-dark': '#0e7490',
    '--theme-primary-rgb': '8, 145, 178',
    '--theme-accent': '#2dd4bf',
    '--theme-sidebar-bg': '#042f2e',
    '--theme-sidebar-bg2': '#0a3d3c',
    '--theme-content-bg': '#ecfeff',
    '--theme-table-th': 'linear-gradient(180deg, #ecfeff 0%, #cffafe 100%)',
    '--theme-table-th-color': '#164e63',
    '--theme-title-gradient': 'linear-gradient(90deg, #0891b2, #2dd4bf)',
    '--theme-btn-gradient': 'linear-gradient(135deg, #0891b2 0%, #0d9488 100%)',
    '--theme-btn-hover-gradient': 'linear-gradient(135deg, #06b6d4 0%, #14b8a6 100%)',
    '--theme-navbar-border': 'linear-gradient(90deg, rgba(8,145,178,.3), rgba(45,212,191,.1), transparent) 1',
    '--theme-sidebar-title': 'linear-gradient(90deg, #67e8f9, #5eead4)',
  },
};

// 环境默认主题映射
const envDefaultTheme: Record<string, string> = {
  pro: 'tech',
  pro_party: 'amber',
};

export function applyTheme(themeKey: string) {
  const vars = themes[themeKey] || themes.cyber;
  const root = document.documentElement;
  Object.entries(vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
  document.body.setAttribute('data-theme-mode', themeKey);
  localStorage.setItem(STORAGE_KEY, themeKey);
}

export function getCurrentTheme(): string {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && themes[saved]) return saved;
  const mode = import.meta.env.MODE;
  return envDefaultTheme[mode] || 'cyber';
}

export function initTheme() {
  applyTheme(getCurrentTheme());
}
